// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { DashboardDataDto } from '../models';
// @ts-ignore
import type { DashboardDataRequestDto } from '../models';
/**
 * RecruitmentBoardApi - axios parameter creator
 */
export const RecruitmentBoardApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Recruitment Board
         * @param {DashboardDataRequestDto} dashboardDataRequestDto Dashboard data request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecruitmentBoard: async (dashboardDataRequestDto: DashboardDataRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dashboardDataRequestDto' is not null or undefined
            assertParamExists('getRecruitmentBoard', 'dashboardDataRequestDto', dashboardDataRequestDto)
            const localVarPath = `/api/v1/recruitment/board`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dashboardDataRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RecruitmentBoardApi - functional programming interface
 */
export const RecruitmentBoardApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RecruitmentBoardApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Recruitment Board
         * @param {DashboardDataRequestDto} dashboardDataRequestDto Dashboard data request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRecruitmentBoard(dashboardDataRequestDto: DashboardDataRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DashboardDataDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRecruitmentBoard(dashboardDataRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RecruitmentBoardApi.getRecruitmentBoard']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RecruitmentBoardApi - factory interface
 */
export const RecruitmentBoardApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RecruitmentBoardApiFp(configuration)
    return {
        /**
         * 
         * @summary Recruitment Board
         * @param {DashboardDataRequestDto} dashboardDataRequestDto Dashboard data request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecruitmentBoard(dashboardDataRequestDto: DashboardDataRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<DashboardDataDto> {
            return localVarFp.getRecruitmentBoard(dashboardDataRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RecruitmentBoardApi - interface
 */
export interface RecruitmentBoardApiInterface {
    /**
     * 
     * @summary Recruitment Board
     * @param {DashboardDataRequestDto} dashboardDataRequestDto Dashboard data request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getRecruitmentBoard(dashboardDataRequestDto: DashboardDataRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<DashboardDataDto>;

}

/**
 * RecruitmentBoardApi - object-oriented interface
 */
export class RecruitmentBoardApi extends BaseAPI implements RecruitmentBoardApiInterface {
    /**
     * 
     * @summary Recruitment Board
     * @param {DashboardDataRequestDto} dashboardDataRequestDto Dashboard data request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getRecruitmentBoard(dashboardDataRequestDto: DashboardDataRequestDto, options?: RawAxiosRequestConfig) {
        return RecruitmentBoardApiFp(this.configuration).getRecruitmentBoard(dashboardDataRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}

